module.exports = {"Create Role":"创建身份","Create User":"創建用戶","Lists":"列表視圖","Normal View":"普通模式","Nested View":"嵌套資源","Parallel View":"平行資源"}


//////////////////
// WEBPACK FOOTER
// ./examples/lang/test-zh-Hant.json
// module id = 324
// module chunks = 0